module.exports = __webpack_public_path__ + "img/cont_icon01.bc19b95f.svg";